<span cdk-overlay-origin #trigger="cdkOverlayOrigin"></span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayWidth]="300"
  (backdropClick)="removeDropdown()"
  cdkConnectedOverlayHasBackdrop="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  cdkConnectedOverlayPush="true"
>
  <rt-dropdown>
    <rt-dropdown-header>
      {{ 'app.email_templates.placeholder_categories_header' | translate }}
    </rt-dropdown-header>
    <div #placeholdersList class="dropdown">
      <rt-dropdown-item
        #item
        *ngFor="let placeholder of state.placeholders; trackBy: trackByPlaceholderName"
        [highlighted]="placeholder.id === state.placeholders[selectedPlaceholderIndex].id"
        (click)="insertPlaceholder(placeholder)"
        layout-vertical
      >
        <div layout-vertical>
          <rt-heading variant="heading">
            <span class="preserve-whitespace" text-primary margin-right-small-xx>[ </span>
            {{ withoutBrackets(placeholder.id) }}
            <span class="preserve-whitespace" text-primary margin-left-small-xx> ]</span>
          </rt-heading>
          <span
            [innerHTML]="
              placeholder.interpolated ? placeholder.value : placeholder.data.description
            "
            class="description"
          >
          </span>
        </div>
      </rt-dropdown-item>
    </div>
  </rt-dropdown>
</ng-template>
